import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/Login.vue'
import MainLayout from '../layouts/MainLayout.vue'
import Home from '../views/Home.vue'
import AdRevenueEntry from '../components/AdRevenueEntry.vue'
import SystemConfigManagement from '../components/SystemConfigManagement.vue'
import AppInfoManagement from '../components/AppInfoManagement.vue'
import UserManagement from '../components/UserManagement.vue'
import UserWithdrawalManagement from '../components/UserWithdrawalManagement.vue'
import RiskManagement from '../components/RiskManagement.vue'
import CoinFlowManagement from '../components/CoinFlowManagement.vue'
import AdPoolSettlementManagement from '../components/AdPoolSettlementManagement.vue'
import LeaderLevelManagement from '../components/LeaderLevelManagement.vue'
import InviteReward from '../components/InviteReward.vue'
import InviteRewardFlowManagement from '../components/InviteRewardFlowManagement.vue'
import WithdrawalOptionManagement from '../components/WithdrawalOptionManagement.vue'
import NewbieLessonManagement from '../components/NewbieLessonManagement.vue'
import AdminManagement from '../components/AdminManagement.vue'
import AdminLoginLog from '../components/AdminLoginLog.vue'
import AgentManagement from '../components/AgentManagement.vue'
import AgentSettlementManagement from '../components/AgentSettlementManagement.vue'

const STAFF_ONLY_PATHS = [
  '/system/admins',
  '/system/login-logs',
  '/system/config',
  '/system/app',
  '/newbie-lesson',
  '/withdrawal-option',
  '/leader-level',
  '/invite-reward',
  '/risk-management',
  '/system/agents'
]

const AGENT_ALLOWED_PATHS = [
  '/ad-revenue',
  '/user-management',
  '/coin-flow',
  '/invite-reward-flow',
  '/agent-settlement'
]

function isAgentRole(role) {
  return role === 2
}

function isStaffRole(role) {
  return role === 0 || role === 1
}

// 忽略重复导航错误
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

Vue.use(Router)

const businessChildren = [
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: { title: '首页' },
    beforeEnter(to, from, next) {
      const role = parseInt(localStorage.getItem('role'), 10)
      if (isAgentRole(role)) {
        next('/ad-revenue')
      } else {
        next()
      }
    }
  },
  {
    path: '/ad-revenue',
    name: 'AdRevenueQuery',
    component: AdRevenueEntry,
    meta: { title: '广告收入' }
  },
  {
    path: '/system/config',
    name: 'SystemConfigManagement',
    component: SystemConfigManagement
  },
  {
    path: '/system/app',
    name: 'AppInfoManagement',
    component: AppInfoManagement
  },
  {
    path: '/newbie-lesson',
    name: 'NewbieLessonManagement',
    component: NewbieLessonManagement,
    meta: { title: '新手课堂' }
  },
  {
    path: '/user-management',
    name: 'UserManagement',
    component: UserManagement
  },
  {
    path: '/user-withdrawal',
    name: 'UserWithdrawalManagement',
    component: UserWithdrawalManagement
  },
  {
    path: '/withdrawal-option',
    name: 'WithdrawalOptionManagement',
    component: WithdrawalOptionManagement,
    meta: { title: '提现档位配置' }
  },
  {
    path: '/leader-level',
    name: 'LeaderLevelManagement',
    component: LeaderLevelManagement,
    meta: { title: '团长等级配置' }
  },
  {
    path: '/invite-reward',
    name: 'InviteReward',
    component: InviteReward,
    meta: { title: '直邀提现奖励' }
  },
  {
    // 勿用 /admin-*：线上 Nginx 常把 location /admin 代理到后端，会与 API 前缀冲突
    path: '/system/admins',
    name: 'AdminManagement',
    component: AdminManagement,
    meta: { title: '管理员管理' }
  },
  {
    path: '/system/agents',
    name: 'AgentManagement',
    component: AgentManagement,
    meta: { title: '代理管理' }
  },
  {
    path: '/agent-settlement',
    name: 'AgentSettlementManagement',
    component: AgentSettlementManagement,
    meta: { title: '结算管理' }
  },
  {
    path: '/system/login-logs',
    name: 'AdminLoginLog',
    component: AdminLoginLog,
    meta: { title: '系统日志' }
  },
  {
    path: '/risk-management',
    name: 'RiskManagement',
    component: RiskManagement,
    meta: { title: '风控管理' }
  },
  {
    path: '/coin-flow',
    name: 'CoinFlowManagement',
    component: CoinFlowManagement,
    meta: { title: '金币明细' }
  },
  {
    path: '/invite-reward-flow',
    name: 'InviteRewardFlowManagement',
    component: InviteRewardFlowManagement,
    meta: { title: '奖励明细' }
  },
  {
    path: '/ad-pool-settlement',
    name: 'AdPoolSettlementManagement',
    component: AdPoolSettlementManagement,
    meta: { title: '叠包开包流水' }
  }
]

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Root',
      component: Login
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/data-dashboard',
      redirect: '/home'
    },
    {
      path: '/app',
      component: MainLayout,
      redirect: '/home',
      children: businessChildren
    }
  ]
})

// 全局路由守卫：role 0/1 总后台，role 2 代理后台
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const role = parseInt(localStorage.getItem('role'), 10)

  if (to.path === '/login' || to.path === '/') {
    if (token) {
      next(isAgentRole(role) ? '/ad-revenue' : '/home')
    } else if (to.path === '/') {
      next('/login')
    } else {
      next()
    }
    return
  }

  if (!token) {
    next('/login')
    return
  }

  if (!isStaffRole(role) && !isAgentRole(role)) {
    localStorage.removeItem('token')
    localStorage.removeItem('role')
    next('/login')
    return
  }

  if (isAgentRole(role)) {
    if (STAFF_ONLY_PATHS.includes(to.path) || !AGENT_ALLOWED_PATHS.includes(to.path)) {
      next('/ad-revenue')
      return
    }
  }

  next()
})

export default router
